<div nz-row [nzGutter]="[16, 6]" *ngIf="isNotSameUser">
	<div nz-col [nzSpan]="24">
		<div nz-row nzJustify="space-between">
			<app-splitbutton [elements]="[cancelButton]"></app-splitbutton>
		</div>
	</div>
	<div nz-col [nzSpan]="24">
		<app-roles-edit showLabel="project" [user]="user" [useGlobalRoles]="true"></app-roles-edit>
	</div>
	<div nz-col [nzSpan]="24" *ngFor="let project of projects$ | async">
		<app-roles-edit showLabel="project" [user]="user" [project]="project"></app-roles-edit>
	</div>
</div>

<div nz-row [nzGutter]="[16, 6]" *ngIf="!isNotSameUser">
	<div nz-col [nzSpan]="24">
		<div nz-row nzJustify="space-between">
			<app-splitbutton [elements]="[cancelButton]"></app-splitbutton>
		</div>
	</div>
	<div nz-col [nzSpan]="24">
		<nz-alert
				*ngIf="!isNotSameUser"
				nzType="warning" nzShowIcon
				nzMessage="{{ 'message.warning.sameUser' | translate }}"
				nzDescription="{{ 'message.warning.sameUser_description' | translate }}"
		>
		</nz-alert>
	</div>
</div>

